function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
import React from "react";
import PropTypes from "prop-types";

const Cart = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  style: {
    width: size,
    height: size
  },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation'
}), title ? /*#__PURE__*/React.createElement("title", null, title) : null, " ", /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M19.2 14l2.76-8a.75.75 0 00.04-.35s-.06-.24-.13-.33a.75.75 0 00-.62-.32H6.47L6 2.6a.75.75 0 00-.74-.6H2.75a.75.75 0 100 1.5h1.9l2.56 13.05a2.75 2.75 0 103.29 2.7c0-.43-.11-.86-.31-1.24h5.12a2.72 2.72 0 001.39 3.78 2.75 2.75 0 101.05-5.29h-9l-.36-2h10.1c.16 0 .31 0 .44-.1a.86.86 0 00.27-.4zM7.75 20.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM19 19.25a1.25 1.25 0 11-2.5.02 1.25 1.25 0 012.5-.02zM8.08 13.01l-1.33-6.5h13.44L17.95 13l-9.87.01z"
}, " "));

Cart.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,

  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,

  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default Cart;